import { getAncestorTypes } from './get-ancestor-types.js';

/** find object of type and return the whole lineage (parent children relation from `obj`) */
function getLineage({ obj, type, query, lineage = [obj], ancestors = getAncestorTypes(type) }) {
    if (obj.type === type) {
        if (!query || query(obj))
            return lineage;
    }
    if (!ancestors.includes(obj.type))
        return []; // stop if it couldn't be an ancestor
    for (const child of obj.children) {
        const result = getLineage({ obj: child, type, query, lineage: [...lineage, child] });
        if (result.length)
            return result;
    }
    return [];
}

export { getLineage };
//# sourceMappingURL=get-lineage.js.map
